export const IOF = 0.0738;
export const ADJUST_VALUE = 0.931272;

export const formatPolicyStatus = (status) => PolicyStatus[status] || '';
export const formatProposalStatus = (status) => ProposalStatus[status] || '';
export const PARTNER_77_ID = 38;

const ProposalStatus = {
  awaiting_inspection: 'Aguardando vistoria',
  awaiting_vistei: 'Aguardando aprovação de fotos',
  awaiting_complementar: 'Aguardando fotos complementares',
  awaiting_registration: 'Aguardando cadastro',
  awaiting_complementar_report: 'Aguardando aprovação das fotos complementares',
  awaiting_payment: 'Aguardando pagamento',
  awaiting_mga_communication: 'Aguardando comunicação de emissão',
  activated: 'Ativada',
  rejected: 'Rejeitada',
  cancelled: 'Cancelada',
  expired: 'Expirada',
};

const PolicyStatus = {
  active: 'Ativo',
  canceled: 'Cancelado',
  awaiting_cancellation: 'Aguardando cancelamento',
};

export const PartnerProduct = {
  corporate: 'corporate',
  dealer: 'dealer',
  runoff: 'runOff',
  franchise: 'franquias',
  advisory: 'assessorias',
  enterprise: 'enterprise',
};

export const getCurrentSubdomain = () => {
  if (typeof window === 'undefined') return process.env.REACT_APP_DEV_SUBDOMAIN || 'seven';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host === '::1') {
    return process.env.REACT_APP_DEV_SUBDOMAIN || 'seven';
  }
  return host.split('.')[0];
};
